import { Component, ViewChild, ElementRef, AfterViewInit , OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ApiService } from '../../api/api.service';
import { first } from 'rxjs/operators';
import { result } from 'lodash';
import { FormService } from '../../api/form.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-testdashboard',
  templateUrl: './testdashboard.component.html',
  styleUrls: ['./testdashboard.component.css']
})
export class TestdashboardComponent implements OnInit {

  valName: any ;
  valEmail: any;
  valRefId: any;
  valMobile: any;

  dash_applypost: any;
  dash_area: any;
  dash_c_area: any;
  dash_c_district: any;
  dash_c_doorno: any;
  dash_c_pincode: any;
  dash_c_state: any;
  dash_c_streetname: any;
  dash_c_vtc: any;
  dash_category: any;
  dash_certificate: any;
  dash_district: any;
  dash_divyang: any;
  dash_dob: any;
  dash_doorno: any;
  dash_email: any;
  dash_fathername: any;
  dash_gender: any;
  dash_image: any;
  dash_jobtype: any;
  dash_maritalstatus: any;
  dash_mobno: any;
  dash_name: any;
  dash_nationality: any;
  dash_orgtype: any;
  dash_pastexperience: any;
  dash_pincode: any;
  dash_qualification: any;
  dash_refno: any;
  dash_relevent: any;
  dash_resume: any;
  dash_state: any;
  dash_streetname: any;
  dash_vtc: any;
  dash_yearofpass:any;
  dash_edu_table:any;
  dash_prof_table:any;
  dash_wrkexp_table:any;

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private formaction: FormService,
    private router: Router,
  ) { }

  ngOnInit(): void {

    window.localStorage.getItem('regNo');
    var results = [{refno: window.localStorage.getItem('regNo')}];

    this.api.listDashboard(results).subscribe((result:any)=>{

      this.dash_applypost = result[0]['applypost'];
      this.dash_area = result[0]['area'];
      this.dash_c_area = result[0]['c_area'];
      this.dash_c_district = result[0]['c_district'];
      this.dash_c_doorno = result[0]['c_doorno'];
      this.dash_c_pincode = result[0]['c_pincode'];
      this.dash_c_state = result[0]['c_state'];
      this.dash_c_streetname = result[0]['c_streetname'];
      this.dash_c_vtc = result[0]['c_vtc'];
      this.dash_category = result[0]['category'];
      this.dash_certificate = result[0]['certificate'];
      this.dash_district = result[0]['district'];
      this.dash_divyang = result[0]['divyang'];
      this.dash_dob = result[0]['dob'];
      this.dash_doorno = result[0]['doorno'];
      this.dash_email = result[0]['email'];
      this.dash_fathername = result[0]['fathername'];
      this.dash_gender = result[0]['gender'];
      this.dash_image = result[0]['image'];
      this.dash_jobtype = result[0]['jobtype'];
      this.dash_maritalstatus = result[0]['maritalstatus'];
      this.dash_mobno = result[0]['mobno'];
      this.dash_name = result[0]['name'];
      this.dash_nationality = result[0]['nationality'];
      this.dash_orgtype = result[0]['orgtype'];
      this.dash_pastexperience = result[0]['pastexperience'];
      this.dash_pincode = result[0]['pincode'];
      this.dash_qualification = result[0]['qualification'];
      this.dash_refno = result[0]['refno'];
      this.dash_relevent = result[0]['relevent'];
      this.dash_resume = result[0]['resume'];
      this.dash_state = result[0]['state'];
      this.dash_streetname = result[0]['streetname'];
      this.dash_vtc = result[0]['vtc'];
      });

      this.api.listDashboardEdu(results).subscribe((result:any)=>{
        console.log(result);
        console.log(JSON.stringify(result));
        this.dash_edu_table = result;
        for(var i=0; i<this.dash_edu_table.length; i++){
          this.dash_yearofpass = JSON.stringify(this.dash_edu_table[i]['yearofpass']);
          console.log("yearofpass: " + JSON.stringify(this.dash_edu_table[i]['yearofpass']));
        }
      });

      this.api.listDashboardProf(results).subscribe((result:any)=>{
        this.dash_prof_table = result;
      });

      this.api.listDashboardWrkexp(results).subscribe((result:any)=>{
        this.dash_wrkexp_table = result;
      });



  }


  edit(){
    this.router.navigateByUrl('/testeditreg');
  }


public rollno:any;
public text1:any;
public text2:any;
public uplImg:any;
public uplRes:any;



}
